/* eslint-disable */
import styled, { css } from 'styled-components';

import { Headline } from 'ggApp/shared/common/Typography';

import WidgetGrid from 'ggApp/shared/components/widgets/grid';
import WidgetCta from 'ggApp/shared/components/widgets/cta';

const Wrap = styled.div`
    background: rgba(51,51,51,.05);
    border-radius: 8px;
    padding: ${({ theme }) => theme.spacers.XXL};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        padding: ${theme.spacers.L} 0 ${theme.spacers.L} ${theme.spacers.L};
        margin-right: 0px;
    `};
`;

const Title = styled(Headline)`
    margin-bottom: ${({ theme }) => theme.spacers.L};
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        ${theme.typography.Subheadline} 
    `};
`;

const Grid = styled(WidgetGrid)`
    && {
        margin: ${({ theme }) => theme.spacers.XXL} 0px 0px;
    }
`;

const Cta = styled(WidgetCta)`
    align-self: flex-start;
    margin: ${({ theme }) => theme.spacers.XL} 0 0;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        position: relative;
    `};
`;

export {
    Wrap, Title, Grid, Cta,
};
